<template>
  <v-list-item ripple
    v-if="!isEditing"
    class="it-hv"
  >
    <v-list-item-avatar class="my-0">
      <v-icon small>fal fa-tag</v-icon>
    </v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-title>{{ printName }}</v-list-item-title>
      <v-list-item-subtitle>{{ printKana }} &mdash; {{ printHep }}</v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon
            v-on="on"
            color="secondary"
            :loading="isThisLoading"
            @click="edit"
          >
            <v-icon small>fal fa-pencil</v-icon>
          </v-btn>
        </template>
        <span>編集する</span>
      </v-tooltip>
    </v-list-item-action>
  </v-list-item>
  <v-container v-else>
    <v-subheader>名前</v-subheader>
    <v-row dense class="pb-4">
      <v-col cols="12" sm="6" class="px-3">
        <v-text-field label="姓" required
          v-model="form.name[0]"
          :rules="rules.name"
        />
      </v-col>
      <v-col cols="12" sm="6" class="px-3">
        <v-text-field label="名" required
          v-model="form.name[1]"
          :rules="rules.name"
        />
      </v-col>
      <v-col cols="12" sm="6" class="px-3">
        <v-text-field required
          v-model="form.kana[0]"
          label="せい"
          :rules="rules.kana"
        />
      </v-col>
      <v-col cols="12" sm="6" class="px-3">
        <v-text-field required
          v-model="form.kana[1]"
          label="めい"
          :rules="rules.kana"
        />
      </v-col>
      <v-col cols="12" sm="6" class="px-3">
        <v-text-field label="Last Name（姓）"
          v-model="form.hep[0]"
          :rules="rules.hep"
        />
      </v-col>
      <v-col cols="12" sm="6" class="px-3">
        <v-text-field label="First Name（名）"
          v-model="form.hep[1]"
          :rules="rules.hep"
        />
      </v-col>
    </v-row>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
export default {
  name: 'clientAboutBasicName',
  props: [
    'status',
    'data'
  ],
  data () {
    return {
      form: {
        name: ['', ''],
        kana: ['', ''],
        hep: ['', '']
      },
      rules: {
        name: [
          v => !!v || '必須項目です'
        ],
        kana: [
          v => !!v || '必須項目です',
          v => !/[^ぁ-ん]/.test(v) || '平仮名のみ入力有効です'
        ],
        hep: [
          v => !/[^A-z]/.test(v) || '英字のみ入力有効です'
        ]
      }
    }
  },
  methods: {
    prepare: function () {
      if (
        this.$props.data &&
        this.$props.data.name && this.$props.data.name.length &&
        this.$props.data.kana && this.$props.data.kana.length &&
        this.$props.data.hep
      ) {
        this.$set(this, 'form', {
          name: [
            this.$props.data.name[0] || '',
            this.$props.data.name[1] || ''
          ],
          kana: [
            this.$props.data.kana[0] || '',
            this.$props.data.kana[1] || ''
          ],
          hep: [
            this.$props.data.hep[0] || '',
            this.$props.data.hep[1] || ''
          ]
        })
      }
    },
    edit: function () {
      this.prepare()
      this.$emit('emit', {
        action: 'edit',
        data: {
          type: 'name'
        }
      })
    },
    getForm: function () {
      return this.form
    }
  },
  computed: {
    isEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        ['name', 'all'].includes(this.$props.status.editing)
      )
    },
    isThisEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        this.$props.status.editing === 'name'
      )
    },
    isLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        ['name', 'all'].includes(this.$props.status.loading)
      )
    },
    isThisLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        this.$props.status.loading === 'name'
      )
    },
    printName () {
      return (
        this.$props.data &&
        this.$props.data.name &&
        this.$props.data.name.length
      ) ? this.$props.data.name.join(' ') : ''
    },
    printKana () {
      return (
        this.$props.data &&
        this.$props.data.kana &&
        this.$props.data.kana.length
      ) ? this.$props.data.kana.join(' ') : ''
    },
    printHep () {
      return (
        this.$props.data &&
        this.$props.data.hep &&
        this.$props.data.hep.length
      ) ? this.$props.data.hep.join(' ') : ''
    }
  }
}
</script>
